// Note:
// _menu: nếu là các menu
// _act: nếu là các action của button, ...

export const GlobalPolcies = {
  managePermission: {
    leftmenu: '5001', //web: menu left - Quản trị hệ thống - Phân quyền
    tai_khoan: '5000', //web: menu left - Tài khoản
  },
  left_menu: {
    sso: {
      dashboard: {
        redirect_template: "",
      }
    }
  }
};
